import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import {
    hideMenus, showMenu, changeClipartCategory, expandClipartIOSButtons, showMainUniverse,
    changeCartoonistTabIndex
} from '../../actions/MenuActions';
import menuType from '../../constants/MenuType';
import appParameters from '../../components/utils/AppParameters';
import mouseUtils from '../../components/utils/MouseUtils';
import { ClipartSelectorListNew } from '../menus/ClipartSelectorListNew';
import { MainUniversesList } from '../menus/MainUniversesList';
import { ClipartSelectorList } from '../menus/ClipartSelectorList';
import { AudioTab } from '../menus/AudioTab';
import locales from '../../locales/LocalesManager';
import playController from '../utils/PlayController';
import videoUtils from '../utils/VideoUtils';
import platformDetection from '../utils/PlatformDetection';
import masterUniverseUtils from '../utils/MasterUniverseUtils';

const UniverseButton = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var isMainUniverse = storeManager.getState().menu.isMainUniverse;
        this.props.dispatch(showMainUniverse(!isMainUniverse));

        mouseUtils.setFocusSequence();
    },
    getColor() {
        var color = properties.BROWSER_SELECTED_COLOR;

        switch (appParameters.currentMainUniverse) {
            case ('nature_science'): { // green
                color = 'rgb(15, 232, 171)';
                break;
            }

            case ('world_history'): { //yellow
                color = 'rgb(255, 243, 128)';
                break;
            }

            case ('fiction'): { // red
                color = 'rgb(243, 146, 163)';
                break;
            }

            case ('generic'): { // blue
                color = 'rgb(140, 200, 223)';
                break;
            }

            case ('alphabet_planet'): { // blue
                color = '#9252da';
                break;
            }
        }

        return color;
    },
    getTextColor() {
        if (appParameters.currentMainUniverse != '' && appParameters.currentMainUniverse != 'alphabet_planet')
            return '#2e2e2e';
        else
            return 'white';
    },
    render() {
        const tabStyle = {
            position: 'absolute',
            backgroundColor: this.getColor(),
            width: this.props.accordionWidth,
            height: properties.BROWSER_BUTTON_HEIGHT - 1,
            paddingLeft: 20,
            top: properties.CLIPART_BUTTON_HEIGHT + 1,
            cursor: 'pointer',
            margin: 0,
            paddingRight: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const spanStyle = {
            color: this.getTextColor(),
            fontSize: 14,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: this.getTextColor()
        };

        var title;
        var universeTitle = masterUniverseUtils.getCurrentUniverseTitle();

        if (universeTitle.indexOf('- ') != -1)
            universeTitle = universeTitle.replaceAll('- ', '');

        if (appParameters.currentMainUniverse == '') {
            title = locales.getCaption('PleaseSelectUniverse', 'other');

            if (!title || title == 'null' || title.length < 1)
                title = 'Please select a universe!';
        } else {
            title = locales.getCaption('UniverseName', 'other');

            if (!title || title == 'null' || title.length < 1)
                title = 'Universe:';

            title = title + ' ' + universeTitle;
        }

        return (
            <button aria-label={title} style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <span style={spanStyle}>{title}</span>
                <i style={iconStyle} className="fa fa-angle-down"></i>
            </button>
        );
    }
});

const ThemeButton = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var isUniversesVisible = storeManager.getState().menu.isUniversesVisible;

        if (isUniversesVisible)
            this.props.dispatch(hideMenus(menuType.ALL_MENUS));
        else
           this.props.dispatch(showMenu(menuType.UNIVERSES_MENU));

        mouseUtils.setFocusSequence();
    },
    getColor() {
        var color = properties.BROWSER_SELECTED_COLOR;

        switch (appParameters.currentMainUniverse) {
            case ('nature_science'): { // green
                color = 'rgb(15, 232, 171)';
                break;
            }

            case ('world_history'): { //yellow
                color = 'rgb(255, 243, 128)';
                break;
            }

            case ('fiction'): { // red
                color = 'rgb(243, 146, 163)';
                break;
            }

            case ('generic'): { // blue
                color = 'rgb(140, 200, 223)';
                break;
            }

            case ('alphabet_planet'): { // purple
                color = '#9252da';
                break;
            }
        }

        return color;
    },
    getTextColor() {
        if (appParameters.currentMainUniverse != '' && appParameters.currentMainUniverse != 'alphabet_planet')
            return '#2e2e2e';
        else
            return 'white';
    },
    render() {
        if (this.props.isMainUniverse)
            return <div/>;

        const tabStyle = {
            position: 'absolute',
            backgroundColor: this.getColor(),
            width: this.props.accordionWidth,
            height: properties.BROWSER_BUTTON_HEIGHT -1,
            paddingLeft: 20,
            top: properties.CLIPART_BUTTON_HEIGHT + properties.BROWSER_BUTTON_HEIGHT + 1,
            cursor: 'pointer',
            margin: 0,
            paddingRight: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const spanStyle = {
            color: this.getTextColor(),
            fontSize: 14,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: this.getTextColor()
        };

        var themeTitle = masterUniverseUtils.getCurrentThemeTitle();
        var title;

        if (appParameters.currentTheme == '') {
            title = locales.getCaption('PleaseSelectTheme', 'other');

            if (!title || title == 'null' || title.length < 1)
                title = 'Please select a theme!';
        } else {
            title = locales.getCaption('ThemeName', 'other');

            if (!title || title == 'null' || title.length < 1)
                title = 'Theme:';

            title = title + ' ' + themeTitle;
        }

        return (
            <button aria-label={title} style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <span style={spanStyle}>{title}</span>
                <i style={iconStyle} className="fa fa-angle-down"></i>
            </button>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(changeClipartCategory(this.props.index));

        if (this.props.index == 2) { // audio
            if (playController.isAudioEditorAvailable())
                playController.toggleAudioEditorMode(true);

            videoUtils.executeAction('reset');
            this.props.dispatch(changeCartoonistTabIndex(10));
        } else if (this.props.index == 1) { // video
            if (appParameters.currentVideoTheme == '' ) {
                this.props.dispatch(showMainUniverse(true));
            } else
                masterUniverseUtils.autoselectClipart(this.props.index);

            this.props.dispatch(changeCartoonistTabIndex(9));
        } else { // cartoonist
            if (appParameters.currentMainUniverse == '' && appParameters.currentTheme == '')
                this.props.dispatch(showMainUniverse(true));
            else
                if (appParameters.currentTheme == '')
                    this.props.dispatch(showMainUniverse(false));

            if (appParameters.currentTheme != '')
                masterUniverseUtils.autoselectClipart(this.props.index);

            this.props.dispatch(changeCartoonistTabIndex(0));
        }
    },
    render() {
        var buttonsLength = 3;
        var position = (this.props.accordionWidth / buttonsLength) * this.props.index;
        var color;
        var textColor;

        if (this.props.index == this.props.clipartCategory)
            color = properties.BROWSER_SELECTED_COLOR;
        else
            color = properties.RECORDING_MENU_BACKGROUND;

        if (this.state.isOver) {
            textColor = '#2299D6';
        } else {
            if (color == properties.BROWSER_SELECTED_COLOR)
                textColor = 'white';
            else
                textColor = properties.BROWSER_SELECTED_COLOR;
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: color,
            width: this.props.accordionWidth / buttonsLength,
            height: properties.CLIPART_BUTTON_HEIGHT,
            left: position,
            top: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        var lineStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: 2,
            height: properties.CLIPART_BUTTON_HEIGHT,
            left: tabStyle.width - 2,
            top: 0,
            display: 'block'
        };

        if (this.props.index == 2)
            lineStyle.display = 'none';

        const spanStyle = {
            color: textColor,
            fontSize: 15,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth / buttonsLength - 4,
            left: 2,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            cursor: 'default'
        };

        var text;

        if (this.props.index == 0)
            text = locales.getCaption('cartoonsCategory', 'other');
        else
        if (this.props.index == 1)
            text = locales.getCaption('videoCategory', 'other');
        else
            text = locales.getCaption('audioCategory', 'other');

        return (
            <button aria-label={text} style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={lineStyle}/>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const ExpandedButton = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!this.isSearch()) {
            if (!this.props.iosButtonsExpanded) {
                this.props.dispatch(expandClipartIOSButtons(true));
                return;
            }

            this.props.dispatch(expandClipartIOSButtons(false));
        }

        this.props.dispatch(changeClipartCategory(this.props.index));

        if (this.props.index == 2) {
            if (playController.isAudioEditorAvailable())
                playController.toggleAudioEditorMode(true);

            videoUtils.executeAction('reset');
        } else
            this.props.dispatch(showMenu(menuType.UNIVERSES_MENU));

        masterUniverseUtils.autoselectClipart(this.props.index);
    },
    isSearch() {
        return storeManager.getState().menu.contextMode == modeType.SEARCH_CONTEXT;
    },
    render() {
        if (!this.isSearch() && !this.props.iosButtonsExpanded && this.props.index != this.props.clipartCategory) { // is collapsed
            return (<div/>);
        }

        var position = properties.CLIPART_BUTTON_HEIGHT * this.props.index;
        var color;
        var textColor;

        if (!this.isSearch() && !this.props.iosButtonsExpanded)
            position = 0;

        if (this.props.index == this.props.clipartCategory)
            color = properties.BROWSER_SELECTED_COLOR;
        else
            color = properties.RECORDING_MENU_BACKGROUND;

        if (color == properties.BROWSER_SELECTED_COLOR)
            textColor = 'white';
        else
            textColor = properties.BROWSER_SELECTED_COLOR;

        const tabStyle = {
            position: 'absolute',
            backgroundColor: color,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            left: 0,
            top: position
        };

        var lineSize = 1;
        var lineStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: tabStyle.width,
            height: lineSize,
            left: 0,
            top: tabStyle.height - lineSize,
            display: 'block'
        };

        var gap = 20;
        const spanStyle = {
            color: textColor,
            fontSize: 15,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 2 * gap,
            left: gap,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            cursor: 'default'
        };

        var text;

        if (this.props.index == 0)
            text = locales.getCaption('cartoonsCategory', 'other');
        else
        if (this.props.index == 1)
            text = locales.getCaption('videoCategory', 'other');
        else
            text = locales.getCaption('audioCategory', 'other');

        var button;

        if (!this.props.iosButtonsExpanded && !this.isSearch()) {
            var iconStyle = {
                position: 'absolute',
                top: 6,
                right: 18,
                color: 'white',
                cursor: 'default',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                userDrag: 'none'
            };

            button = <i style={iconStyle} className={'fa fa-angle-down'}/>;
        }

        return (
            <div style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <span style={spanStyle}>{text}</span>
                {button}
                <span style={lineStyle}/>
            </div>
        );
    }
});

const ClipartButton = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.isUniversesVisible == true)
            this.props.dispatch(hideMenus([menuType.UNIVERSES_MENU]));
        else
            this.props.dispatch(showMenu(menuType.UNIVERSES_MENU));
    },
    render() {
        const tabStyle = {
            position: 'absolute',
            backgroundColor: this.props.color,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            paddingLeft: 20,
            top: properties.CLIPART_BUTTON_HEIGHT,
            margin: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            paddingRight: 0,
            paddingBottom: 0,
            paddingTop: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: 'white'
        };

        var title;

        if (appParameters.currentVideoTheme == '') {
            title = locales.getCaption('PleaseSelectTheme', 'other');

            if (!title || title == 'null' || title.length < 1)
                title = 'Please select a theme!';
        } else {
            title = masterUniverseUtils.getCurrentVideoThemeTitle();
        }

        const topLine = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: tabStyle.width,
            height: 1,
            background: 'white',
            display: 'block'
        };

        return (
            <button aria-label={title} style={tabStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <span style={topLine}></span>
                <span style={spanStyle}>{title}</span>
                <i style={iconStyle} className="fa fa-angle-down"></i>
            </button>
        );
    }
});

const ClipartSelectorNewContent = React.createClass({
    render() {
        const menuStyle = {
            position: 'absolute',
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            top: 0,
            left: 0
        };

        var buttonsHolder;
        var listHolder;

        if (platformDetection.isIOS() && this.props.contextMode == modeType.SEARCH_CONTEXT) {
            // not include list
        } else {
            if (this.props.clipartCategory == 0) {
                if (this.props.isMainUniverse)
                    listHolder =
                        <div>
                            <UniverseButton dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} isMainUniverse={this.props.isMainUniverse}/>
                            <MainUniversesList dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} refreshValue={this.props.refreshValue}/>
                        </div>;
                else
                    listHolder =
                        <div>
                            <UniverseButton dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} isMainUniverse={this.props.isMainUniverse}/>
                            <ThemeButton dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} isUniversesVisible={this.props.isUniversesVisible}/>
                            <ClipartSelectorListNew dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} isUniversesVisible={this.props.isUniversesVisible}/>
                        </div>;
            } else
            if (this.props.clipartCategory == 1) {
                listHolder =
                    <div>
                        <ClipartButton dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} color={properties.BROWSER_SELECTED_COLOR} isUniversesVisible={this.props.isUniversesVisible}/>
                        <ClipartSelectorList dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} isUniversesVisible={this.props.isUniversesVisible}/>
                    </div>;
            } else {
                listHolder = <AudioTab accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} dispatch={this.props.dispatch}/>;
            }
        }

        if (platformDetection.isIOS()) {
            buttonsHolder =
                <div>
                    <ExpandedButton accordionWidth={this.props.accordionWidth} index={0} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory} iosButtonsExpanded={this.props.iosButtonsExpanded}/>
                    <ExpandedButton accordionWidth={this.props.accordionWidth} index={1} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory} iosButtonsExpanded={this.props.iosButtonsExpanded}/>
                    <ExpandedButton accordionWidth={this.props.accordionWidth} index={2} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory} iosButtonsExpanded={this.props.iosButtonsExpanded}/>
                </div>;

            return (
                <div id='universesSelector' style={menuStyle}>
                    {listHolder}
                    {buttonsHolder}
                </div>
            );
        } else {
            buttonsHolder =
                <div>
                    <Button accordionWidth={this.props.accordionWidth} index={0} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory}/>
                    <Button accordionWidth={this.props.accordionWidth} index={1} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory}/>
                    <Button accordionWidth={this.props.accordionWidth} index={2} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory}/>
                </div>;

            return (
                <div id='universesSelector' style={menuStyle}>
                    {buttonsHolder}
                    {listHolder}
                </div>
            );
        }
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var isUniversesVisible = state.menu.isUniversesVisible;
    var isMainUniverse = state.menu.isMainUniverse;
    var accordionWidth = state.accordion.width;
    var clipartCategory = state.menu.clipartCategory;
    var iosButtonsExpanded = state.menu.iosButtonsExpanded;
    var contextMode = state.menu.contextMode;
    var refreshValue = state.menu.refreshValue;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (isUniversesVisible == undefined)
        isUniversesVisible = false;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    if (iosButtonsExpanded == undefined)
        iosButtonsExpanded = false;

    if (isMainUniverse == undefined)
        isMainUniverse = true;

    return {
        isUniversesVisible,
        accordionWidth,
        clipartCategory,
        iosButtonsExpanded,
        contextMode,
        isMainUniverse,
        refreshValue
    };
}

export const ClipartSelectorNew = connect(mapStateToProps)(ClipartSelectorNewContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/ClipartSelectorNew.js
 **/